import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPricesAndPolygons } from 'shared/common/services/fetchPricesAndPolygons';
import { setSelectedPolygon } from 'shared/common/slices/selectedPolygonSlice';
import { IPricesAndPolygonsData } from 'shared/common/types/prices';
import { IThunkApi } from 'shared/common/types/redux';

export const getPricesAndPolygons = createAsyncThunk<IPricesAndPolygonsData, void, IThunkApi>(
  'pricesAndPolygons/getInfo',
  async (_, thunkApi) => {
    const { rejectWithValue, extra, dispatch } = thunkApi;

    try {
      const response = await fetchPricesAndPolygons(extra);

      dispatch(setSelectedPolygon(response.polygons[0]));

      return response;
    } catch (e) {
      extra.logger.error(e);

      return rejectWithValue(e.data);
    }
  },
);
